// TODO NEGOCIO: migrar a una línea de WhatsApp Business.
// Ahora mismo apunta a un móvil particular, lo cual no escala y expone a una
// persona concreta. Cuando exista la línea de empresa, basta con cambiar
// REACT_APP_WHATSAPP_NUMBER — no hace falta tocar código.
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '';

export function hasWhatsAppNumber() {
  return Boolean(WHATSAPP_NUMBER);
}

export function buildWhatsAppUrl(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

// t = the translation function from useT(). Kept as a parameter (rather than
// called internally) so these stay plain, testable functions.
export function buildGeneralWhatsAppMessage(t) {
  return t('whatsapp.prefill');
}

export function buildActivityWhatsAppMessage({
  activity,
  date,
  timeSlot,
  quantities,
}, t) {
  const selectedTickets = activity.ticketTypes
    .map((ticket) => {
      const quantity = quantities[ticket.id] || 0;
      return quantity ? `${quantity} ${ticket.label.toLowerCase()}` : null;
    })
    .filter(Boolean);

  return [
    t('whatsapp.prefill'),
    `Actividad: ${activity.title}`,
    `Fecha: ${date || 'por confirmar'}`,
    `Hora: ${timeSlot || 'por confirmar'}`,
    `Participantes: ${selectedTickets.length ? selectedTickets.join(', ') : 'por confirmar'}`,
    '',
    '¿Puedes confirmarme la disponibilidad y los próximos pasos?',
  ].join('\n');
}
